import React, { Fragment } from "react";
import PropTypes from "prop-types";
import CircularSlider from "@fseehawer/react-circular-slider";
import Spinner from "../../../../common/spinner";
import "./TunersAndInput.style.scss";

const TunersAndInput = ({
  str1,
  str2,
  str3,
  str4,
  volatality = 0,
  returns = 0,
  max_limit = 0,
  max_beta = 0,
  portfolioNameHandler,
  scenario_name,
  btnDisabled,
  scenario_id,
  volatility_type,
  return_type,
  max_limit_type,
  max_beta_type,
  tunersHandler,
  btnHandler,
  creatingPortfolioSpinner,
  failedCreatingPortfolio,
  noScenarioIDreturned,
  displayTuners,
  allocationHundredPercentMessage,
  client_name,
  displayCreateButton,
  absoluteTunersValue,
}) => {
  let sliderHandler = ({ value, type, absoluteTunersValue }) => {
    if (value && typeof tunersHandler === "function" && scenario_id) {
      let val = absoluteTunersValue ? value : value.slice(0, -1);
      let obj = { id: scenario_id, type, value: val };
      tunersHandler(obj);
    }
  };
  return (
    <div className="Tunersip__tuners container" style={{ width: "100%" }}>
      <div className="Tunersip__tuners__heading row">
        {displayTuners && (
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            Tune parameters to apply
          </div>
        )}

        <div
          className={`${
            displayTuners ? "col-lg-6 col-md-6" : "col-lg-12 col-md-12"
          } col-sm-12 col-xs-12`}
        >
          {client_name
            ? `Create portfolio  (${client_name})`
            : "Create portfolio"}
        </div>
      </div>
      <div className="Tunersip__tuners__content ">
        <div className="row">
          {displayTuners ? (
            <Fragment>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 Tunersip__tuners__content__slider">
                <div>
                  <CircularSlider
                    label={str1}
                    // appendToValue="%"
                    labelFontSize="0px"
                    valueFontSize="1.5em"
                    knobSize={14}
                    labelColor="#3c548e"
                    knobColor="#3c548e"
                    progressColorFrom="#3bcbe3"
                    progressColorTo="#3bcbe8"
                    verticalOffset="-0.018em"
                    progressSize={14}
                    trackColor="#eeeeee"
                    trackSize={14}
                    min={0}
                    data={Array.from({ length: 101 }, (v, k) => k + "%")}
                    dataIndex={volatality}
                    onChange={(value) =>
                      sliderHandler({
                        value,
                        type: volatility_type,
                        absoluteTunersValue,
                      })
                    }
                    width={100}
                  />
                  <div className="Tunersip__tuners__content__slider_title">
                    VOLATILITY
                  </div>
                </div>
                <div>
                  <CircularSlider
                    label={str2}
                    // appendToValue="%"
                    labelFontSize="0px"
                    valueFontSize="1.5em"
                    knobSize={14}
                    labelColor="#3c548e"
                    knobColor="#3c548e"
                    progressColorFrom="#3bcbe3"
                    progressColorTo="#3bcbe8"
                    verticalOffset="-0.018em"
                    progressSize={14}
                    trackColor="#eeeeee"
                    trackSize={14}
                    min={0}
                    // max={100}
                    data={Array.from({ length: 101 }, (v, k) => k + "%")}
                    dataIndex={returns}
                    onChange={(value) =>
                      sliderHandler({
                        value,
                        type: return_type,
                        absoluteTunersValue,
                      })
                    }
                    width={100}
                  />
                  <div className="Tunersip__tuners__content__slider_title">
                    Returns
                  </div>
                </div>
                {str3 && max_limit_type && (
                  <div className="Tunersip__tuners__pl">
                    <CircularSlider
                      label={str3}
                      labelFontSize="0px"
                      valueFontSize="1.5em"
                      knobSize={14}
                      labelColor="#3c548e"
                      knobColor="#3c548e"
                      progressColorFrom="#3bcbe3"
                      progressColorTo="#3bcbe8"
                      verticalOffset="-0.018em"
                      progressSize={14}
                      trackColor="#eeeeee"
                      trackSize={14}
                      min={0}
                      // max={100}
                      data={Array.from({ length: 101 }, (v, k) => k + "%")}
                      dataIndex={max_limit}
                      onChange={(value) =>
                        sliderHandler({
                          value,
                          type: max_limit_type,
                          absoluteTunersValue,
                        })
                      }
                      width={100}
                    />
                    <div className="Tunersip__tuners__content__slider_title">
                      Max Limit
                    </div>
                  </div>
                )}
                {str4 && max_beta_type && (
                  <div className="Tunersip__tuners__pl">
                    <CircularSlider
                      label={str4}
                      labelFontSize="0px"
                      valueFontSize="1.5em"
                      knobSize={14}
                      labelColor="#3c548e"
                      knobColor="#3c548e"
                      progressColorFrom="#3bcbe3"
                      progressColorTo="#3bcbe8"
                      verticalOffset="-0.018em"
                      progressSize={14}
                      trackColor="#eeeeee"
                      trackSize={14}
                      min={0}
                      // max={100}
                      data={Array.from({ length: 301 }, (v, k) => k / 100 + "")}
                      dataIndex={max_beta}
                      onChange={(value) =>
                        sliderHandler({
                          value,
                          type: max_beta_type,
                          absoluteTunersValue,
                        })
                      }
                      width={100}
                    />
                    <div className="Tunersip__tuners__content__slider_title">
                      Max Beta
                    </div>
                  </div>
                )}
              </div>

              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 Tunersip__tuners__content_create">
                <div className="Tunersip__tuners__content_create_heading">
                  portfolio name
                </div>
                <div className="Tunersip__tuners__content_create_ip">
                  <input
                    type="text"
                    value={scenario_name}
                    onChange={(e) => portfolioNameHandler(e.target.value)}
                  />
                </div>

                {displayCreateButton === false ? null : (
                  <div className="Tunersip__tuners__content_create_btn">
                    <button
                      className="btn btn-db btn_spinner"
                      disabled={btnDisabled}
                      onClick={(e) => btnHandler(e)}
                    >
                      {creatingPortfolioSpinner && <Spinner size="small" />}
                      create <i className="fa fa-angle-right"></i>
                    </button>
                  </div>
                )}
                {/* {creatingPortfolioSpinner && (
                  <div className="Tunersip__tuners__content_create_spinner">
                    Your portfolio request has been submitted, please wait
                    &nbsp;
                    <Spinner size="small" />
                  </div>
                )} */}
                {(failedCreatingPortfolio || noScenarioIDreturned) && (
                  <div className="Tunersip__tuners__content_create_spinner error_message">
                    {failedCreatingPortfolio
                      ? `Failed to create portfolio. Please try again later.`
                      : noScenarioIDreturned
                      ? `Failed to load resource, Please try again later.`
                      : null}
                  </div>
                )}
              </div>
            </Fragment>
          ) : (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                <div className="Tunersip__tuners__content_create_heading">
                  portfolio name
                </div>
                <div className="Tunersip__tuners__content_create_ip">
                  <input
                    type="text"
                    value={scenario_name}
                    onChange={(e) => portfolioNameHandler(e.target.value)}
                  />
                </div>
                {allocationHundredPercentMessage && (
                  <div className="Tunersip__tuners__content_create_msg">
                    Please make sure asset allocations add up to 100%.
                  </div>
                )}
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <button
                  className="btn btn-db btn_spinner float_btn"
                  disabled={btnDisabled}
                  onClick={(e) => btnHandler(e)}
                >
                  {creatingPortfolioSpinner && <Spinner size="small" />}
                  create <i className="fa fa-angle-right"></i>
                </button>
              </div>
              {(failedCreatingPortfolio || noScenarioIDreturned) && (
                <div
                  style={{ float: "right", margin: "10px 0" }}
                  className="error_message"
                >
                  {failedCreatingPortfolio
                    ? `Failed to create portfolio. Please try again later.`
                    : noScenarioIDreturned
                    ? `Failed to load resource, Please try again later.`
                    : null}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

TunersAndInput.propTypes = {
  heading: PropTypes.string,
  volatality: PropTypes.number,
  returns: PropTypes.number,
};

export default TunersAndInput;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/common/tunersAndinput/TunersAndInput.jsx